import React           from 'react';
import ProgressBar     from '../ProgressBar';
import PropTypes       from '../PropTypes';
import ComponentHelper from '../../helper/ComponentHelper';

class TableProcessFormatter extends React.Component {
    render () {
        if (this.props.value !== -1) {
            return (
                <ProgressBar
                    process={this.props.value}
                />
            );
        }

        return null;
    }

    shouldComponentUpdate (nextProps, nextState) {
        return ComponentHelper.shouldComponentUpdate(
            this,
            Component,
            nextProps,
            nextState,
        );
    }
}

const Component = TableProcessFormatter;

Component.propTypes = {
    value: PropTypes.any,
};

Component.defaultProps = {
    value: [],
};

Component.renderAffectingProps = Object.keys(Component.defaultProps);

Component.renderAffectingStates = [];

export default Component;